import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var CloudRaining05 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "cloud-raining05",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M16 18.5 15 21m-7-2.5L7 21m5-2.5L11 21m-4-6c-2.7614 0-5-2.2386-5-5s2.2386-5 5-5c.0332 0 .0662.0003.0992.001C8.0094 3.2196 9.8622 2 12 2c2.5192 0 4.6429 1.6938 5.2943 4.0046A4.5748 4.5748 0 0 1 17.5 6c2.4853 0 4.5 2.0147 4.5 4.5S19.9853 15 17.5 15H7Z"
    })
  }));
};
export default CloudRaining05;